export default __webpack_public_path__ + "static/media/warning.51e58419.svg";